<template>
  <el-dialog :visible.sync="showModal" :title="id ? '编辑试卷' : '添加试卷'">
    <el-form :model="form" :rules="rules" label-width="100px" ref="form">
      <el-form-item label="排序号" prop="sortNum">
        <el-input v-model.number="form.sortNum" @input="form.sortNum = Number(form.sortNum) || ''" placeholder="序号越小越靠前" maxlength="10"/>
      </el-form-item>
      <el-form-item label="试卷标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入试卷标题" />
      </el-form-item>
      <el-form-item label="所属分类" prop="classificationId">
        <el-select v-model="form.classificationId" style="width:100%" placeholder="请选择所属分类">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in typeData" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布状态" prop="publishStatus">
        <el-radio-group v-model="form.publishStatus">
          <el-radio :label="item.id" v-for="(item,index) in publishStatus" :key="index">{{item.name}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input v-model="form.remarks" placeholder="请输入描述" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="showModal = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { projectMoudel, typeMoudel } from "../../mixins"
import { publishStatus } from "../../dict"
import { examPaperAdd, examPaperGet, examPaperUpdate } from "../../api"
const rules = {
  title: [
    { required: true, message: '请输入试卷标题', trigger: 'blur' },
  ],
  classificationId: [
    { required: true, message: '请选择所属分类', trigger: 'change' },
  ],
  publishStatus: [
    { required: true, message: '请选择发布状态', trigger: 'change' },
  ]
}
export default {
  mixins: [projectMoudel, typeMoudel],
  data () {
    return {
      publishStatus,
      rules,
      showModal: false,
      form: {
        title: "",
        sortNum: null,
        classificationId: null,
        publishStatus: 1,
        remarks: null
      },
      id: null,
    }
  },
  methods: {
    init (id) {
      this.showModal = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
        this.getprojectPage()
        this.id = id
        if (this.id) {
          this.detail(id)
        }
      })
    },
    async detail (id) {
      const res = await examPaperGet({ id })
      const data = res.data
      Object.keys(this.form).forEach(keys => {
        this.form[keys] = data[keys]
      })
    },
    submit () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const params = { ...this.form }
          if (this.id) {  //编辑
            params.id = this.id
            const res = await examPaperUpdate(params)
            this.$message.success('更新成功！')
            this.showModal = false
            this.$emit('update', true)
          } else { //新增
            const res = await examPaperAdd(params)
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('操作成功！')
            this.showModal = false
            this.$emit('update', true)
          }
        } else {
          return false;
        }
      });

    }
  }
}
</script>

<style>
</style>